module.exports = __webpack_public_path__ + "static/media/partner-deal-red.99035d74.jpg";